export const svgStyle = {
  position: 'absolute',
  right: 0,
  transition: 'all ease 0.3s',
  width: '2.8rem',
  top: 0
};

export const svgPathStyle = {
  animation: 'svg-stroke 0.55s cubic-bezier(0.65, 0, 0.45, 1) forwards',
  strokeDasharray: 59,
  strokeDashoffset: 59,
  strokeWidth: 2.5,
  transformOrigin: '50% 50%'
};
